//export const API_URL = 'https://dc865f6b-5cb1-48f8-aabf-8e7ad711acbd.mock.pstmn.io'
export const API_URL = 'http://localhost:3000'
export const STAGING_API_URL = 'http://lego.qa.freighttiger.com'
export const LEGO = 'lego'
